<div id="footer" class="sticky-footer bg-default pt-5">
   <!-- Main -->
   <div class="container-fluid">
      <div class="row">
         <div class="col-md-3 col-sm-6">
            <img class="footer-logo" src="assets/images/logo-2-white.png" alt="" height="100">
         </div>
         <div class="col-md-3 col-sm-6 ">
            
            <!-- <p class="text-white">Morbi convallis bibendum urna ut viverra. Maecenas quis consequat libero, a feugiat eros. Nunc ut lacinia tortor morbi ultricies laoreet ullamcorper phasellus semper.</p> -->
            <div class="text-widget text-white">
               <span class="text-white"  >{{propertyDetails.address}}</span>

                <br>
               Phone: <span class="text-white">
                  <a *ngIf="propertyDetails.mobile"  href="tel:{{propertyDetails.mobile}}" class="text-white">{{propertyDetails.mobile}}</a> 

               </span><br>
               E-Mail: <span class="text-white"> 
                  <a *ngIf="propertyDetails.email" href="mailto:support@thehotelmate.com" class="text-white" >support@thehotelmate.com</a>

                </span><br>
            </div> 
            <!-- <a href="tel:+0800265663" > <img class="footer-logo" src="assets/images/call-banner.png" alt=""  height="80px"></a> -->
            <div class="mt-4">
               <a target="_blank" href="https://www.instagram.com/thehotelmate/" class="btn btn-neutral btn-icon-only btn-round btn-lg" data-toggle="tooltip" data-original-title="Follow us">
               <i class="fa fa-instagram"></i>
               </a>
               <a target="_blank" href="https://www.facebook.com/The-Hotel-Mate-113242730585106" class="btn btn-neutral btn-icon-only btn-round btn-lg" data-toggle="tooltip" data-original-title="Like us">
               <i class="fa fa-facebook-square"></i>
               </a>
             
               <a *ngIf="propertyDetails.twitter" target="_blank" href="{{propertyDetails.twitter}}" class="btn btn-neutral btn-icon-only  btn-lg btn-round" data-toggle="tooltip" data-original-title="Follow us">
               <i class="fa fa-twitter"></i>
               </a>
               <!-- <a target="_blank" href="https://github.com/" class="btn btn-neutral btn-icon-only btn-round btn-lg" data-toggle="tooltip" data-original-title="Star on Github">
               <i class="fa fa-github"></i>
               </a> -->
              
            </div>
         </div>
         <div class="col-md-2 col-sm-6 ">
            <ul class="footer-links">
               <!-- <li><a class="text-white" routerLink='/session/login'>Login</a></li>
               <li><a class="text-white" routerLink='/session/signup'>Sign Up</a></li>
               <li><a class="text-white" routerLink='/session/forgot-password'>Forgot Password</a></li> -->
               <li><a class="text-white" routerLink='/registration'>Add Listing</a></li>
               <!-- <li><a class="text-white" routerLink='/pricing'>Pricing</a></li> -->
               <li><a class="text-white" routerLink='/about-us'>About</a></li>
            </ul>
         </div>
         <div class="col-md-2  col-sm-12">
            <ul class="footer-links">
               <!-- <li><a class="text-white" routerLink='/user-profile'>Profile</a></li> -->
               <li><a class="text-white" routerLink='/posts'>Blog</a></li>
               <!-- <li><a class="text-white" routerLink='/invoice'>Invoice</a></li>
               <li><a class="text-white" routerLink='/booking'>Booking</a></li> -->
               <li><a class="text-white" routerLink='/contact-us'>Contact</a></li>
            </ul>
         </div>
         <div class="col-md-2 col-sm-6 ">
            <h6 style="color: white;">Get The Mobile App</h6>
            <div class="row">
               <div class="col-12">
                  <a target="_blank" href="{{androidAppUrl}}"><img class="mb-05 applogo1" width="150px" src="assets/images/playdownload.png"  alt="" ></a>
       
            <a target="_blank" href="{{iosAppUrl}}"><img class=" mb-05 applogo2" width="150px"  src="assets/images/appdownload.png"  alt="" ></a>
               </div>
            
            </div>
         </div>
      </div>
      <!-- Copyright -->
      <div class="row">
         <div class="col-md-12">
            <div class="copyrights text-white">© 2020 TheHotelMate. All Rights Reserved.</div>
         </div>
      </div>
   </div>
</div>

